var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS = {
    ONLINE: 'ONLINE',
    ANSWERED: 'ANSWERED',
    FINISHED: 'FINISHED',
    REJECTED: 'REJECTED',
    PHYSICIAN_WILL_CALL_BACK: 'PHYSICIAN_WILL_CALL_BACK',
    DISCONNECTED: 'DISCONNECTED',
    PHYSICIAN_IS_BUSY: 'PHYSICIAN_IS_BUSY'
};

Object.freeze(Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS);